let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("fvaoj")).then(() => parcelRequire('3mPtI'));